import axiosInstance from '../utils/axios'

const apiPath = '/api/diagram'

const DiagramApi = {
  /**
   * Get all diagrams with optional filters
   * @param {Object} filters - Optional filters object
   * @param {string} filters.engine_type - Engine type ID
   * @param {string} filters.engine_power - Engine power value
   * @param {string} filters.model - Model ID
   * @param {number} filters.year - Year value
   * @param {string} filters.category - Category ID
   * @returns {Promise} Axios response promise
   */
  getAll: function (filters = {}) {
    return axiosInstance.get(apiPath, {
      params: filters
    })
  },

  search: function (filters = {}) {
    return axiosInstance.get(`${apiPath}/search`, {
      params: filters
    })
  }
}

export default DiagramApi